import _ from 'underscore';

export default class ProductEndUses {
  constructor($scope, ProductService) {
    $scope.selected_products = [];
    $scope.product_categories = window.product_categories;
    $scope.product_end_uses = window.product_end_uses;
    this.ProductService = ProductService;

    $scope.quick_search_end_uses = this.quick_search_end_uses.bind(this);
    $scope.select_product = this.select_product.bind(this);
    $scope.remove_selected_product = this.remove_selected_product.bind(this);
    $scope.add_product_end_uses = this.add_product_end_uses.bind(this);
    $scope.clear_selected_products = this.clear_selected_products.bind(this);
    $scope.$watch('product_category_id', this.load_groups.bind(this));
    $scope.$watch('product_group_id', this.load_products.bind(this));

    this.$scope = $scope;
  }

  load_groups() {
    if (this.$scope.product_category_id) {
      this.ProductService.get_groups(this.$scope.product_category_id).then((data) => {
        this.$scope.product_groups = data.groups;
        if (data.groups.length > 0) {
          this.$scope.product_group_id = data.groups[0].id;
        }
      });
    }
  }

  load_products() {
    if (this.$scope.product_group_id) {
      this.ProductService.get_products(this.$scope.product_group_id).then((data) => {
        this.$scope.products = data.products;
      });
    }
  }

  select_product(product) {
    let products = this.$scope.selected_products;

    if (product.checked) {
      products.push(product);
    } else {
      products.splice(_.indexOf(products, product), 1);
    }
  }

  remove_selected_product(selected_product) {
    let products = this.$scope.selected_products;
    products.splice(_.indexOf(products, selected_product), 1);

    const product = _.findWhere(this.$scope.products, {id: selected_product.id});
    if (product) {
      product.checked = false;
    }
  }

  add_product_end_uses() {
    const end_uses = _.where(this.$scope.product_end_uses, {checked: true});
    if (end_uses.length === 0) {
      alert('Please select at least one end use!');
      return;
    }

    this.$scope.updating_products = true;
    this.ProductService.add_end_uses_to_products(
      _.pluck(this.$scope.selected_products, 'id'),
      _.pluck(end_uses, 'id')
    )
    .then(() => {
      this.$scope.updating_products = false;
    });
  }

  clear_selected_products() {
    this.$scope.selected_products = [];
    _.each(this.$scope.products, (product) => {
      product.checked = false;
    });
  }

  quick_search_end_uses() {
    if (this.$scope.quick_filter) {
      var regex = new RegExp(this.$scope.quick_filter, 'i');
      _.each(this.$scope.product_end_uses, function(end_use) {
        end_use.visible = end_use.title.search(regex) > -1;
      });

      this.$scope.search_filter = {
        visible: true
      };
    } else {
      this.$scope.search_filter = {};
    }
  }
}

ProductEndUses.$inject = ['$scope', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-end-uses-add.ctrl.js